// pages/Videos.js
import React, { useEffect, useState } from 'react';
import '../styles/VideoSection1.css';
import Carousel from '../components/Carousel';


function VideosENG() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [filter, setFilter] = useState('all');
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
{ id: 1, title: 'Testimonial from a victim of digital violence', description: 'A woman\'s experience with online blackmail and how she overcame it', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Digital violence',   youtubeId: 'dQw4w9WgXcQ' },
{ id: 2, title: 'Harassment on social media', description: 'A young woman shares her story with cyberbullying and how it impacted her daily life', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Cyber harassment' ,   youtubeId: 'dQw4w9WgXcQ' },
{ id: 3, title: 'Online revenge', description: 'How a romantic relationship spiraled into a digital nightmare and the legal safeguards available to victims', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Online blackmail' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 4, title: 'Deepfake and AI', description: 'A victim tells her story with deepfake images', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Privacy protection' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 5, title: 'Cyberstalking', description: 'A woman is persistently stalked online by an unknown individual', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Internet safety' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 6, title: 'Sharing images without consent', description: 'A painful experience with non-consensual image sharing and the path to regaining dignity', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Privacy protection' ,   youtubeId: 'dQw4w9WgXcQ' },
{ id: 7, title: 'Targeted hate speech', description: 'An activist faces orchestrated campaigns of hatred and defamation online', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Incitement to violence' ,   youtubeId: 'dQw4w9WgXcQ' },
{ id: 8, title: 'Online blackmail', description: 'A young woman falls victim to financial blackmail after her personal accounts are hacked', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Digital blackmail' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 9, title: 'Digital violence in the workplace', description: 'An employee faces persistent harassment through professional communication channels', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Cyber harassment' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 10, title: 'Personal account hacking', description: 'A Facebook account is hacked and used for defamation', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Internet safety' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 11, title: 'Bullying of a journalist', description: 'A journalist endures bullying for covering women\'s issues', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Incitement to violence' ,   youtubeId: 'dQw4w9WgXcQ'},
{ id: 12, title: 'Online sextortion', description: 'The sexual exploitation of a minor girl through online games', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Digital blackmail' ,  youtubeId: 'dQw4w9WgXcQ' },
{ id: 13, title: 'Fake account creation', description: 'A woman finds multiple fake profiles impersonating her to share offensive content', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Privacy protection' ,  youtubeId: 'dQw4w9WgXcQ' },
{ id: 14, title: 'Online death threats', description: 'A human rights activist receives daily death threats on social media', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Digital violence leading to suicide' ,  youtubeId: 'dQw4w9WgXcQ'},
{ id: 15, title: 'Digital domestic violence', description: 'A husband uses technology to control his wife', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Digital violence' ,  youtubeId: 'dQw4w9WgXcQ' },
{ id: 16, title: 'A story of survival and hope', description: 'A digital violence survivor recounts her journey of healing and reclaiming her life', thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg', category: 'Digital violence' ,  youtubeId: 'dQw4w9WgXcQ' }
  ];

  const categories = [
    'all',
    'Digital violence leading to suicide',
    'Digital blackmail',
    'Privacy protection',
    'Internet safety',
    'Cyber harassment',
    'Incitement to violence',
    'Digital violence'
  ];

  const filteredVideos = filter === 'all'
    ? videos
    : videos.filter(video => video.category === filter);

  // Fonctions pour le modal
  const openVideoModal = (video) => {
    setSelectedVideo(video);
    document.body.style.overflow = 'hidden';
  };

  const closeVideoModal = () => {
    setSelectedVideo(null);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') closeVideoModal();
    };

    if (selectedVideo) {
      window.addEventListener('keydown', handleEscape);
    }
    return () => window.removeEventListener('keydown', handleEscape);
  }, [selectedVideo]);

  return (
    <div className="videos-page" >
      {/* Hero Section */}
      <div style={{
        padding: '80px 0 40px',
        textAlign: 'center',
        backgroundImage: 'url(/images/cover.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        width: '100%',
        marginLeft: 'calc(-50vw + 50%)',
        minHeight: '400px'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
          zIndex: 1
        }}></div>
        <div className="container" style={{ position: 'relative', zIndex: 2, padding: '0 20px', direction: 'ltr' }}>
          <img
            src="/images/Asset6.png"
            alt="Videos Icon"
            style={{ width: '80px', height: '80px', objectFit: 'contain' }}
          />
          <h1 style={{
            fontSize: '3.5rem',
            marginBottom: '20px',
            background: 'linear-gradient(135deg, var(--primary-orange), var(--secondary-orange))',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            direction: 'ltr'
          }}>
          Testimonials
          </h1>
          <p style={{ fontSize: '1.3rem', color: 'var(--text-light)', maxWidth: '700px', margin: '0 auto', direction: 'ltr' }}>
Real-life stories and experiences with digital violence. Names have been changed for privacy.
            </p>
        </div>
      </div>

      {/* Main Content */}
      <div style={{ background: 'var(--secondary-black)', padding: '60px 0', direction: 'ltr' }}>
        <div className="container">
          {/* Filter Section */}
          <div style={{ marginBottom: '50px', textAlign: 'center', direction: 'ltr' }}>
            <h3 style={{ fontSize: '1.8rem', marginBottom: '25px', color: 'var(--white)', direction: 'ltr' }}>
              Filter by category
            </h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '15px' }}>
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setFilter(category)}
                  style={{
                    padding: '12px 30px',
                    borderRadius: '25px',
                    border: filter === category ? '2px solid var(--primary-orange)' : '2px solid rgba(255, 107, 53, 0.3)',
                    background: filter === category ? 'var(--primary-orange)' : 'var(--primary-black)',
                    color: 'var(--white)',
                    fontSize: '1.1rem',
                    fontWeight: filter === category ? '700' : '500',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    fontFamily: 'Cairo, sans-serif',
                    direction: 'ltr'
                  }}
                  onMouseEnter={(e) => {
                    if (filter !== category) {
                      e.target.style.borderColor = 'var(--primary-orange)';
                      e.target.style.background = 'rgba(255, 107, 53, 0.1)';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (filter !== category) {
                      e.target.style.borderColor = 'rgba(255, 107, 53, 0.3)';
                      e.target.style.background = 'var(--primary-black)';
                    }
                  }}
                >
                  {category === 'all' ? 'All videos' : category}
                </button>
              ))}
            </div>
            <p style={{ marginTop: '20px', fontSize: '1.1rem', color: 'var(--text-light)', direction: 'ltr' }}>
              Showing {filteredVideos.length} of {videos.length} testimonials
            </p>
          </div>

          {/* Videos Grid avec modal */}
          <div className="video-grid">
            {filteredVideos.map((video) => (
              <div key={video.id} className="video-card" style={{ direction: 'ltr' }}>
                <div
                  className="video-thumbnail"
                  onClick={() => openVideoModal(video)}
                >
                  <img src={video.thumbnail} alt={video.title} />
                  <div className="play-button"></div>
                </div>
                <div className="video-info">
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                    <h3 className="video-info-title" style={{ margin: 0, textAlign:'left' }}>{video.title}</h3>
                    <span style={{
                      padding: '5px 12px',
                      background: 'rgba(255, 107, 53, 0.2)',
                      borderRadius: '15px',
                      fontSize: '0.85rem',
                      color: 'var(--primary-orange)',
                      fontWeight: '600',
                      whiteSpace: 'nowrap',
                      textAlign:'left'
                    }}>
                      {video.category}
                    </span>
                  </div>
                  <p className="video-info-description" style={{ textAlign: 'left' }}>{video.description}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Modal Video */}
          {selectedVideo && (
            <div
              className="video-modal-overlay"
              onClick={closeVideoModal}
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.9)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000
              }}
            >
              <div
                className="video-modal-content"
                onClick={(e) => e.stopPropagation()}
                style={{
                  position: 'relative',
                  width: '90%',
                  maxWidth: '1200px',
                  backgroundColor: 'var(--primary-black)',
                  borderRadius: '15px',
                  padding: '20px',
                  direction: 'ltr'
                }}
              >
                <button
                  onClick={closeVideoModal}
                  style={{
                    position: 'absolute',
                    top: '-15px',
                    right: '-15px',
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    border: 'none',
                    background: 'var(--primary-orange)',
                    color: 'white',
                    fontSize: '24px',
                    cursor: 'pointer',
                    zIndex: 1001
                  }}
                  aria-label="Close"
                >
                  ×
                </button>
                <div className="video-player-wrapper" style={{ position: 'relative', paddingTop: '56.25%' }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}?autoplay=1&rel=0`}
                    title={selectedVideo.title}
                    style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </div>
              </div>
            </div>
          )}

          {/* No Results */}
          {filteredVideos.length === 0 && (
            <div style={{ textAlign: 'center', padding: '60px 20px', color: 'var(--text-light)', direction: 'ltr' }}>
              <h3 style={{ fontSize: '2rem', marginBottom: '15px' }}>No testimonials in this category</h3>
              <p style={{ fontSize: '1.2rem' }}>Try another category or select "All videos" to view all testimonials</p>
            </div>
          )}






    </div>
  </div>

  {/* Footer Note */}
  <div style={{
    background: 'var(--secondary-black)',
    padding: '30px 0',
    textAlign: 'center',
    borderTop: '1px solid rgba(255, 107, 53, 0.2)'
  }}>
  </div>
    <Carousel />
</div>
);
}

export default VideosENG;
